export const navigationRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        iconClass: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'companies',
      displayName: 'menu.companies',
      meta: {
        iconClass: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'assembly_line',
      displayName: 'menu.assemblyLine',
      meta: {
        iconClass: 'vuestic-iconset-time',
      },
      disabled: true,
      children: [
        {
          name: 'orders',
          displayName: 'menu.orders',
        },
      ],
    },
    {
      name: 'indicators',
      displayName: 'menu.indicators',
      meta: {
        iconClass: 'vuestic-iconset-statistics',
      },
      disabled: true,
      children: [
        {
          name: 'works',
          displayName: 'menu.works',
        },
        {
          name: 'ranking',
          displayName: 'menu.ranking',
        },
        {
          name: 'mounting_time',
          displayName: 'menu.mounting_time',
        },
        {
          name: 'free_time',
          displayName: 'menu.free_time',
        },
        {
          name: 'products_by_boxes',
          displayName: 'menu.products_by_boxes',
        },
        {
          name: 'products_by_pallets',
          displayName: 'menu.products_by_pallets',
        },
      ],
    },
    {
      name: 'loads',
      displayName: 'menu.loads',
      meta: {
        iconClass: 'vuestic-iconset-maps',
      },
      disabled: true,
      children: [
        {
          name: 'loads',
          displayName: 'menu.loads',
        },
        // {
        //   name: 'crossdocking',
        //   displayName: 'menu.crossdocking',
        // },
        {
          name: 'load_palletizing',
          displayName: 'menu.load_palletizing',
        },
        {
          name: 'load_sequence',
          displayName: 'menu.load_sequence',
        },
        {
          name: 'deliveries',
          displayName: 'menu.deliveries',
        },
      ],
    },
    // {
    //   name: 'statistics',
    //   displayName: 'menu.statistics',
    //   meta: {
    //     iconClass: 'vuestic-iconset-statistics',
    //   },
    //   disabled: true,
    //   children: [
    //     {
    //       name: 'charts',
    //       displayName: 'menu.charts',
    //     },
    //     {
    //       name: 'progress-bars',
    //       displayName: 'menu.progressBars',
    //     },
    //   ],
    // },
    // {
    //   name: 'forms',
    //   displayName: 'menu.forms',
    //   meta: {
    //     iconClass: 'vuestic-iconset-forms',
    //   },
    //   disabled: true,
    //   children: [
    //     {
    //       name: 'form-elements',
    //       displayName: 'menu.formElements',
    //     },
    //     {
    //       name: 'medium-editor',
    //       displayName: 'menu.mediumEditor',
    //     },
    //   ],
    // },
    // {
    //   name: 'tables',
    //   displayName: 'menu.tables',
    //   meta: {
    //     iconClass: 'vuestic-iconset-tables',
    //   },
    //   children: [
    //     {
    //       name: 'markup',
    //       displayName: 'menu.markupTables',
    //     },
    //     {
    //       name: 'data',
    //       displayName: 'menu.dataTables',
    //     },
    //   ],
    // },
    // {
    //   name: 'ui',
    //   displayName: 'menu.uiElements',
    //   meta: {
    //     iconClass: 'vuestic-iconset-ui-elements',
    //   },
    //   disabled: true,
    //   children: [
    //     {
    //       name: 'buttons',
    //       displayName: 'menu.buttons',
    //     },
    //     {
    //       name: 'cards',
    //       displayName: 'menu.cards',
    //     },
    //     {
    //       name: 'chat',
    //       displayName: 'menu.chat',
    //     },
    //     {
    //       name: 'chips',
    //       displayName: 'menu.chips',
    //     },
    //     {
    //       name: 'collapses',
    //       displayName: 'menu.collapses',
    //     },
    //     {
    //       name: 'colors',
    //       displayName: 'menu.colors',
    //     },
    //     {
    //       name: 'color-pickers',
    //       displayName: 'menu.colorPickers',
    //     },
    //     {
    //       name: 'file-upload',
    //       displayName: 'menu.fileUpload',
    //     },
    //     {
    //       name: 'grid',
    //       displayName: 'menu.grid',
    //     },
    //     {
    //       name: 'icon-sets',
    //       displayName: 'menu.icons',
    //       children: [
    //         {
    //           displayName: 'concrete',
    //           name: 'icon-set',
    //         },
    //       ],
    //     },
    //     {
    //       name: 'lists',
    //       displayName: 'menu.lists',
    //     },
    //     {
    //       name: 'modals',
    //       displayName: 'menu.modals',
    //     },
    //     {
    //       name: 'notifications',
    //       displayName: 'menu.notifications',
    //     },
    //     {
    //       name: 'popovers',
    //       displayName: 'menu.popovers',
    //     },
    //     {
    //       name: 'rating',
    //       displayName: 'menu.rating',
    //     },
    //     {
    //       name: 'sliders',
    //       displayName: 'menu.sliders',
    //     },
    //     {
    //       name: 'spacing',
    //       displayName: 'menu.spacing',
    //     },
    //     {
    //       name: 'spinners',
    //       displayName: 'menu.spinners',
    //     },
    //     {
    //       name: 'tabs',
    //       displayName: 'menu.tabs',
    //     },
    //     {
    //       name: 'timelines',
    //       displayName: 'menu.timelines',
    //     },
    //     {
    //       name: 'tree-view',
    //       displayName: 'menu.treeView',
    //     },
    //     {
    //       name: 'typography',
    //       displayName: 'menu.typography',
    //     },
    //   ],
    // },
    // {
    //   name: 'maps',
    //   displayName: 'menu.maps',
    //   meta: {
    //     iconClass: 'vuestic-iconset-maps',
    //   },
    //   disabled: true,
    //   children: [
    //     {
    //       name: 'google-maps',
    //       displayName: 'Google Maps',
    //     },
    //     {
    //       name: 'yandex-maps',
    //       displayName: 'Yandex Maps',
    //     },
    //     {
    //       name: 'leaflet-maps',
    //       displayName: 'Leaflet Maps',
    //     },
    //     {
    //       name: 'bubble-maps',
    //       displayName: 'Bubble Maps',
    //     },
    //     {
    //       name: 'line-maps',
    //       displayName: 'Line Maps',
    //     },
    //   ],
    // },
    // {
    //   name: 'pages',
    //   displayName: 'menu.pages',
    //   meta: {
    //     iconClass: 'vuestic-iconset-files',
    //   },
    //   disabled: true,
    //   children: [
    //     {
    //       name: 'login',
    //       displayName: 'Login/Signup',
    //     },
    //     {
    //       name: '404-pages',
    //       displayName: '404 Pages',
    //     },
    //   ],
    // },
    {
      name: 'transports',
      displayName: 'menu.transports',
      meta: {
        iconClass: 'vuestic-iconset-settings',
      },
      children: [
        {
          name: 'vehicles',
          displayName: 'menu.vehicles',
        },
        {
          name: 'vehicle_types',
          displayName: 'menu.vehicle_types',
        },
        {
          name: 'bay_types',
          displayName: 'menu.bay_types',
        },
      ],
    },
    {
      name: 'products',
      displayName: 'menu.products',
      meta: {
        iconClass: 'vuestic-iconset-components',
      },
      children: [
        {
          name: 'products',
          displayName: 'menu.products',
        },
        {
          name: 'packages',
          displayName: 'menu.packages',
        },
        {
          name: 'product_criticalities',
          displayName: 'menu.product_criticalities',
        },
        {
          name: 'product_sequence',
          displayName: 'menu.product_sequence',
        },
        {
          name: 'fragilities',
          displayName: 'menu.fragilities',
        },
      ],
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        iconClass: 'vuestic-iconset-user',
      },
      children: [
        {
          name: 'user',
          displayName: 'menu.user',
        },
        {
          name: 'roles',
          displayName: 'menu.roles',
        },
        {
          name: 'pallet_users',
          displayName: 'menu.pallet_users',
        },
      ],
    },
    {
      name: 'mounting_flow',
      displayName: 'menu.mounting_flow',
      meta: {
        iconClass: 'vuestic-iconset-extras',
      },
      children: [
        {
          name: 'statuses',
          displayName: 'menu.statuses',
        },
        {
          name: 'mounting_flow',
          displayName: 'menu.mounting_flow',
        },
      ],
    },
    {
      name: 'audits',
      displayName: 'menu.audits',
      meta: {
        iconClass: 'vuestic-iconset-components',
      },
      children: [
        {
          name: 'load_audits',
          displayName: 'menu.loads',
        },
        {
          name: 'order_step_audits',
          displayName: 'menu.order_step_audits',
        },
        {
          name: 'product_audits',
          displayName: 'menu.product_audits',
        },
        {
          name: 'user_audits',
          displayName: 'menu.user_audits',
        },
      ],
    },
    {
      name: 'data_reports',
      displayName: 'menu.data_reports',
      meta: {
        iconClass: 'vuestic-iconset-components',
      },
      children: [
        {
          name: 'data_integrations',
          displayName: 'menu.data_integrations',
        },
        {
          name: 'notifications',
          displayName: 'menu.notificatins',
        },
      ],
    },
  ],
}
